import EditCannedMessageModal from './EditCannedMessage'
export default EditCannedMessageModal
